---
title: Chorus
description: "A chorus device: a rate or a note value, a depth, a delay and a mix, a panel that draws the sweep of the delay, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-chorus" />

Thickens the sound with a short delay that a slow oscillator sweeps up and down. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="chorus" kind="device" />

## Controls

<DeviceControls device="chorus">
<Control id="rateHz">How fast the oscillator sweeps the delay.</Control>
<Control id="sync">Takes the rate from a note value and the tempo of the host. See [Tempo sync](/docs/devices#tempo-sync).</Control>
<Control id="division">The note value of one cycle of the oscillator.</Control>
<Control id="depth">How far the oscillator moves the delay.</Control>
<Control id="delayMs">The delay the sweep is centred on.</Control>
<Control id="mix">The balance of the delayed signal and the dry one.</Control>
</DeviceControls>

## Panel

The panel draws the delay time over two seconds as the oscillator moves it. `chorusSweep(state)` is what it draws. With Sync on, it draws the oscillator at the rate it really has.

<DeviceUsage name="chorus" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

The output of the oscillator, scaled by the depth, is added to the delay time. The sweep is kept inside the delay, so the time never goes negative.
